module.exports = __webpack_public_path__ + "img/WB.4297b305.png";